import { ACHIEVEMENTS } from '../models/achievements';
import { useAchievementAlerts } from '../state/achievementAlerts';
import { Sheet } from './Sheet';

/** Slides up when achievements are earned during play. Any way of closing it acknowledges every pending one. */
export function AchievementEarnedSheet() {
  const pending = useAchievementAlerts((s) => s.pending);
  const dismiss = useAchievementAlerts((s) => s.dismiss);
  if (pending.length === 0) return null;
  const rows = ACHIEVEMENTS.filter((a) => pending.includes(a.id));
  const title = rows.length > 1 ? 'Achievements unlocked!' : 'Achievement unlocked!';
  return (
    <Sheet label={title} onClose={dismiss}>
      <div className="achievement-popup" data-testid="achievement-popup" onClick={dismiss}>
        <h2 className="t-title-l achievement-popup-title">{title}</h2>
        <ul className="achievement-list">
          {rows.map((a) => (
            <li key={a.id} className="achievement-row" data-testid={`achievement-alert-${a.id}`}>
              <span className="achievement-emoji" aria-hidden="true">{a.emoji}</span>
              <span className="achievement-text">
                <span className="t-title-m">{a.name}</span>
                <span className="achievement-desc">{a.description}</span>
              </span>
            </li>
          ))}
        </ul>
        <p className="achievement-hint">Tap to continue</p>
      </div>
    </Sheet>
  );
}
